<template>
<div class="wrap">
  <Breadcrumb>
        <BreadcrumbItem v-for="(item, index) in levelList" :key="index">
          <router-link :to="{path:item.path+ '?' +item.query}">{{item.meta.title}}</router-link>
        </BreadcrumbItem>
  </Breadcrumb>
   <p class="title">
      {{ contentTitle }}
    </p>
</div>
</template>
<script>
export default {
  props: {
  },
  data () {
    return {
      levelList: [],
      contentTitle: '',
      showLeve: false
    };
  },
  watch: {
    $route () {
      this.getBreadcrumb();

    }
  },
  created () {
    this.getBreadcrumb();

  },
  methods: {
    getBreadcrumb () {
      /**由于路由用了重定向,重定向的路由没有name,所以这里改用meta中的title来过滤 */
      this.levelList = this.$route.matched.filter(item => item.meta.title);
      let queryArr = Object.keys(this.$route.query)
      this.levelList.forEach((i, iIndex) => {
        // 暂定5级
        switch (iIndex) {
        case 0:
          this.levelList[iIndex].query = ''
          break;
        case 1:
          this.levelList[iIndex].query = `${queryArr[iIndex - 1] }=${ this.$route.query[queryArr[iIndex - 1]]}`
          break;
        case 2:
          this.levelList[iIndex].query = `${queryArr[iIndex-2] }=${ this.$route.query[queryArr[iIndex-2]]}&${queryArr[iIndex - 1] }=${ this.$route.query[queryArr[iIndex - 1]]}`
          break;
        case 3:
          this.levelList[iIndex].query = `${queryArr[iIndex-3] }=${ this.$route.query[queryArr[iIndex-3]]}&${queryArr[iIndex-2] }=${ this.$route.query[queryArr[iIndex-2]]}&${queryArr[iIndex - 1] }=${ this.$route.query[queryArr[iIndex - 1]]}`
          break;
        default:
          this.levelList[iIndex].query = `${queryArr[iIndex-4] }=${ this.$route.query[queryArr[iIndex-4]]}&${queryArr[iIndex-3] }=${ this.$route.query[queryArr[iIndex-3]]}&${queryArr[iIndex-2] }=${ this.$route.query[queryArr[iIndex-2]]}&${queryArr[iIndex - 1] }=${ this.$route.query[queryArr[iIndex - 1]]}`

        }
      })
      this.showLeve= this.levelList.length>1;
      this.contentTitle=this.levelList[this.levelList.length-1].meta.title
    }

  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/common/Layout/breadcrumb/index.vue?8fb9821c